var React = require('react');

function Draw (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-0.001 -1.289)"},React.createElement("path",{"d":"M4.319,2.442,5.732,3.855,2.156,7.431.744,6.018ZM6.8,2.1l-.63-.63a.625.625,0,0,0-.883,0l-.6.6L6.1,3.488l.7-.7A.482.482,0,0,0,6.8,2.1ZM0,8A.161.161,0,0,0,.2,8.2l1.574-.382L.361,6.4Z","transform":"translate(0 0)","fill":"#7e7e7e"})));
}

Draw.defaultProps = {"width":"6.945","height":"6.911","viewBox":"0 0 6.945 6.911"};

module.exports = Draw;

Draw.default = Draw;
